export const usersObject = {
    userData: null,
    isLoading: false,
    isRefreshing: false,
    isDemoLoggingIn: false,
    error: null,
    isSignupSuccess: false,
    isForgotPasswordLoading: false,
    isForgotPasswordSuccess: false,
    forgotPasswordError: null,
    isResetPasswordLoading: false,
    isResetPasswordSuccess: false,
    resetPasswordError: null,
    isResendConfirmationLoading: false,
    isResendConfirmationSuccess: false,
    resendConfirmationError: null,
    // Cookie tracking
    cookieSetHeaderSent: false, // True when backend sends Set-Cookie header
    cookieConfirmed: false, // True when cookie is confirmed written
    // Avatar upload
    isUploadingAvatar: false,
    uploadedAvatarUrl: null,
    uploadAvatarError: null,
}